import ImageStyles from "./styles";

export default function Image({ src, w, h, mt,onClick }) {
    return <ImageStyles onClick={onClick} src={src} w={w} h={h} mt={mt} />
}